<script>
import { user_review_type } from "@/helpers/global.variable";

// Custom Components
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// User review task Component
export default {
  page: {
    title: "User Review",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
  },
  computed: {
    ...authComputed,
  },
  data() {
    return {
      title: "User Review",
      userReviewType: user_review_type,
      ratingOption: [
        { text: "All", value: "all", disabled: false },
        { text: "⭐ ", value: "1", disabled: false },
        { text: "⭐ ⭐ ", value: "2", disabled: false },
        { text: "⭐ ⭐ ⭐ ", value: "3", disabled: false },
        { text: "⭐ ⭐ ⭐  ⭐ ", value: "4", disabled: false },
        { text: "⭐ ⭐ ⭐  ⭐  ⭐ ", value: "5", disabled: false },
      ],
      table: {
        isDataLoading: false,
        tableData: [],
        size: 100,
        next: null,
        previous: null,
      },
      filter: {},
      viewFilter: false,
      forFilter: "",
      reviewImage: "",
    };
  },
  mounted() {
    this.getUserReviewList("?size=" + this.table.size);
  },
  methods: {
    getUserReviewList(query) {
      this.userReviewType.unshift({
        text: "All",
        value: "all",
        disabled: false,
      });
      this.table.isDataLoading = true;
      UserService.getUserReviewListByFilter(query)
        .then((response) => {
          this.table.tableData = [...this.table.tableData, ...response.results];
          this.table.isDataLoading = false;
          this.table.previous = response.previous;
          this.table.next = response.next;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to get more guest
    loadMore: function () {
      if (this.table.next !== null) {
        const str = this.table.next.split("?");
        this.getUserReviewList(`?${str[1]}`);
      }
    },
    // Open filter drawer
    openUserReviewFilter(filter) {
      this.viewFilter = !this.viewFilter;
      this.forFilter = filter;
    },
    filterData() {
      let filterString = "";
      if (this.filter.reviewType && this.filter.reviewType !== "all") {
        filterString = filterString + `?review_type=${this.filter.reviewType}`;
      }
      if (this.filter.rating && this.filter.rating !== "all") {
        if (this.filter.reviewType) {
          filterString = filterString + `&star=${this.filter.rating}`;
        } else {
          filterString = filterString + `?star=${this.filter.rating}`;
        }
      }
      UserService.getUserReviewListByFilter(filterString)
        .then((response) => {
          this.table.tableData = response.results;
          this.openUserReviewFilter();
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    filterReset() {
      this.filter = {};
      this.forFilter = "";
      this.openUserReviewFilter();
      UserService.getUserReviewListByFilter()
        .then((response) => {
          this.table.tableData = response.results;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <div class="card">
      <div class="card-body">
        <div
          class="row"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="isDataLoading"
          infinite-scroll-distance="100"
        >
          <!-- Table -->
          <div class="table-responsive mb-0">
            <table class="table table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>User Name</th>
                  <th>
                    Review Type<span
                      v-if="this.viewFilter && this.forFilter == 'review'"
                    >
                      <b-form-select
                        class="form-select w-50"
                        id="search-user-review"
                        placeholder="Review Type wise Search..."
                        v-model="filter.reviewType"
                        :options="userReviewType"
                        @change="filterData"
                      >
                      </b-form-select>
                    </span>
                    <i
                      v-else
                      class="fas fa-search text-end float-end mt-1"
                      @click="openUserReviewFilter('review')"
                    ></i>
                  </th>
                  <th>
                    Rating
                    <span v-if="this.viewFilter && this.forFilter == 'rating'">
                      <b-form-select
                        class="form-select w-50"
                        id="search-user-review"
                        placeholder="Rating wise Search..."
                        v-model="filter.rating"
                        :options="ratingOption"
                        @change="filterData"
                      >
                      </b-form-select>
                    </span>
                    <i
                      v-else
                      class="fas fa-search text-end float-end mt-1"
                      @click="openUserReviewFilter('rating')"
                    ></i>
                  </th>
                  <th>Description</th>
                  <th>Image</th>
                </tr>
              </thead>
              <tbody v-if="table.isDataLoading && table.tableData.length < 100">
                <tr v-for="number in 20" :key="number">
                  <td class="placeholder-glow" v-for="no in 5" :key="no">
                    <span class="placeholder w-100 placeholder-lg"></span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="(data, index) in table.tableData" :key="index">
                  <td>
                    {{
                      data.guest !== null ? data.guest.first_name : "-"
                    }}&nbsp;
                    {{ data.guest !== null ? data.guest.last_name : "-" }}
                  </td>
                  <td>
                    {{ data.review_type }}
                  </td>
                  <td>
                    <span v-for="st in data.star" :key="st"> ⭐ </span>
                  </td>
                  <td>
                    <span v-if="data.description">{{ data.description }}</span>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <img
                      v-if="data.image != null"
                      class="rounded-circle picture-img"
                      :src="data.image"
                      alt="Avatar"
                      v-b-modal.image-modal
                      @click="
                        () => {
                          reviewImage = data.image;
                        }
                      "
                    />
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!table.isDataLoading && table.tableData.length == 0">
                <tr>
                  <td colspan="18" class="text-center">
                    <img
                      src="@/assets/images/empty.svg"
                      class="img-fluid"
                      alt=""
                    />
                    <p>
                      <span class="text-secondary">No Data Found</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="image-modal"
      centered
      title="View Review Image"
      hide-footer
      title-class="font-18"
      @hidden="
        () => {
          reviewImage = '';
        }
      "
    >
      <img
        :src="reviewImage"
        alt=""
        width="200"
        class="rounded mx-auto d-block border-top-0"
      />
    </b-modal>
  </div>
</template>
<style scoped>
.picture-img {
  height: 25px;
  width: 25px;
  object-fit: cover;
}
</style>
